<template>
    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark p-2" style="height: 100px">
        <div class="py-0 px-0 bg-dark w-100 h-100 d-flex">
            <div style="width: 100px" class="bg-success w-100 h-100"></div>        
        </div>
    </nav>
</template>
<script type="text/babel">
  import { mapState } from 'vuex'

  export default {
        data() {
            return {
                token_count: 12,
                pinFound: true
            }
        },
        computed: mapState(['tries']),
        methods: {},
        mounted: function () {},
        components: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/header.vue